import styled, { keyframes } from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const ReferralHeroDIV = styled.div`
  position: relative;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, white 49.25%),
    linear-gradient(180deg, var(--color--cobalt-100) 0%, rgba(var(--color--cobalt-100-rgb), 0) 100%);
  background-size: 100% 400px;
  background-repeat: no-repeat;
  overflow: hidden;

  ${MEDIA_QUERIES.M} {
    background-size: 80% auto;
    padding-bottom: var(--spacing--M);
  }

  ${MEDIA_QUERIES.XL} {
    background-size: 100% auto;
  }
`;

const LoadingKeyframes = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.1;
  }
`

export const ReferralContentDIV = styled.div`
  padding-top: 40px;
  padding-bottom: 40px;

  ${MEDIA_QUERIES.M} {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  h1 {
    margin-top: 0;
  }

  p {
    margin-bottom: 30px;
    color: var(--color--charcoal-700);

    strong {
      color: var(--color--charcoal-900);
    }
  }

  form {
    width: 100%;
    max-width: 505px;

    ${MEDIA_QUERIES.S} {
      display: flex;
    }

    input {
      ${MEDIA_QUERIES.S} {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        margin-bottom: 0;
      }
    }

    .Button {
      width: 100%;
      white-space: nowrap;

      ${MEDIA_QUERIES.S} {
        width: auto;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  .welcome,
  .error {
    margin: 10px 0;
    color: var(--color--green-700);
    max-width: 505px;
  }

  .error {
    color: var(--color--red-900);
  }

  .small-print {
    display: block;
    margin: 10px 0 0;

    &,
    button {
      color: var(--color--charcoal-700);
      font-style: italic;
    }

    button {
      text-decoration: underline;
    }
  }

  .loading,
  .referral-link,
  .error {
    position: relative;
    display: block;
    max-width: 505px;
    border: 1px solid var(--color--charcoal-400);
    border-radius: 3px;
    height: 52px;
    line-height: 52px;
    padding: 0 16px;
  }

  .loading,
  .error {
    font-style: italic;
    color: var(--color--charcoal-700);

    span {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      background: var(--color--cobalt-300);
      width: 100%;
      height: 100%;
      animation: ${LoadingKeyframes} 1s ease-out infinite alternate;
    }
  }

  .error {
    border-color: var(--color--error-border);
    background: var(--color--error-background-light);
    color: var(--color--error-text);
  }

  .referral-link {
    font-weight: 500;
  }

  .referral-link-wrapper {
    position: relative;
    max-width: 505px;
    transition: background-color 0.3s;

    input {
      background: transparent;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      width: 52px;
      height: 52px;
      color: var(--color--charcoal-600);

      &:hover {
        color: var(--color--cobalt-600);
      }

      .Icon {
        margin-top: -1px;
      }
    }

    &.was-copied {
      background-color: var(--color--green-100);

      .referral-link {
        font-weight: 400;
        font-style: italic;
      }
    }
  }
`;

export const ReferralHeroVideoDIV = styled.div`
  position: relative;
  height: 360px;

  ${MEDIA_QUERIES.S} {
    height: 490px;
  }

  video {
    position: absolute;
    left: 50%;
    transform: translateX(-160px);
    width: 480px;
    height: 360px;

    ${MEDIA_QUERIES.S} {
      position: static;
      transform: none;
      width: 650px;
      height: 490px;
    }
  }
`;
